import {ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {GroupedTable} from '../../../common/models/grouped-table';
import {Currency} from '../../../currency/models/currency.model';
import {PrimeColumn} from '../../../common/models/prime-column';
import {DeviceDetectorService} from '../../../common/device-detection/services/device-detector.service';

import {
  columnsFromXAxisLabels,
  getFrozenColumns,
  getStandardColumns,
  primeColumnFromLabel
} from '../../../common/primeng/frozen-columns';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'mojo-cash-balance-table',
  templateUrl: './cash-balance-table.component.html'
})
export class CashBalanceTableComponent implements OnInit {
  @Input() loading: boolean;
  @Input() data: GroupedTable;
  @Input() totalRow: any;
  @ViewChild('container', { static: true }) dataTableContainerElement: ElementRef;
  @Input() currentCurrency: Currency;

  constructor(private readonly deviceDetectorService: DeviceDetectorService) { }

  selectedRow: any;

  getFrozenColumns(table: GroupedTable): PrimeColumn[] {
    return getFrozenColumns(table, primeColumnFromLabel);
  }

  getIsColumnFrozen(column: any): boolean {
    return column.isFrozen;
  }

  getStandardColumns(table: GroupedTable): PrimeColumn[] {
    return getStandardColumns(table, primeColumnFromLabel);
  }

  getColumns(table: GroupedTable): PrimeColumn[] {
    return columnsFromXAxisLabels(table, primeColumnFromLabel);
  }

  isNumber(field): boolean {
    return !isNaN(field);
  }

  prepareColumnName(col: string): any {
    if (col === 'Total') {
      return `${col} (${this.currencySymbol})`;
    } else {
      return col;
    }
  }

  ngOnInit() {
  }

  ngAfterViewInit() {

  }

  getColSize(size) {
    return size + 'px';
  }

  get currencySymbol(): string {
    return this.currentCurrency ? this.currentCurrency.Symbol : '';
  }

  prepareFieldData(rowData: any, fieldData: any): string {
    if (rowData.isTotalRow && fieldData === 'Total') {
      return `${fieldData} (${this.currencySymbol})`;
    }
    return `${fieldData}`;
  }

  isMobile(): boolean {
    return this.deviceDetectorService.isMobile() || this.deviceDetectorService.isTablet();
  }

}
